// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import { Box, SxProps } from "@outschool/backpack";
import React, { ReactNode } from "react";

interface OverlayProps {
  sx?: SxProps;
  style?: object;
  children: ReactNode;
}

export const Overlay = React.forwardRef(
  (
    { sx = {}, style = {}, children }: OverlayProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    return (
      <Box
        ref={ref}
        sx={[
          {
            display: "block",
            position: "absolute",
            boxSizing: "border-box",
            backgroundColor: "common.white",
            border: "1px solid #E5E5E5",
            borderRadius: "3px",
            maxWidth: "100%",
            zIndex: 2,
            maxHeight: "calc(100vh - 220px)",
            ...style,
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {children}
      </Box>
    );
  }
);

interface OverlayBackdropProps {
  onClick: any;
}

export const OverlayBackdrop = ({ onClick }: OverlayBackdropProps) => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 100,
        background: "rgba(255, 255, 255, 0.75)",
      }}
      onClick={onClick}
      role="presentation"
    />
  );
};
